<template>
    <div class="bg-white shadow overflow-hidden sm:rounded-lg">
        <div v-if="$slots.header" class="px-4 py-5 sm:px-6">
            <slot name="header"/>
        </div>
        <div class="px-4 py-5 sm:px-6 border-gray-200"
             :class="{
                'border-t': $slots.header,
                'border-b': $slots.footer,
            }">
            <slot></slot>
        </div>
        <div v-if="$slots.footer" class="px-4 py-5 sm:px-6 bg-gray-200">
            <slot name="footer"/>
        </div>
    </div>
</template>
